import { call, put, takeLatest } from 'redux-saga/effects';
import * as T from './loyaltyNotificationsTypes';
import * as actions from './loyaltyNotificationsActions';
import * as api from '../../../services/loyaltyProgramApi';

function* fetchNotificationConfigsSaga() {
  try {
    const response: any = yield call(api.getNotificationConfigs);
    const raw = response.data?.data;
    const configs = Array.isArray(raw) ? raw : (raw?.notifications ?? raw?.configs ?? raw?.items ?? []);
    yield put(actions.fetchNotificationConfigsSuccess(configs));
  } catch (error: any) {
    yield put(actions.fetchNotificationConfigsFailure(error.message || 'Failed to fetch notification configs'));
  }
}

function* updateNotificationConfigSaga(action: ReturnType<typeof actions.updateNotificationConfigRequest>) {
  try {
    const { configId, data } = action.payload;
    const response: any = yield call(api.updateNotificationConfig, configId, data);
    yield put(actions.updateNotificationConfigSuccess(response.data?.data));
    // Re-fetch to ensure UI reflects latest server state
    const fetchResponse: any = yield call(api.getNotificationConfigs);
    const raw = fetchResponse.data?.data;
    const configs = Array.isArray(raw) ? raw : (raw?.notifications ?? raw?.configs ?? raw?.items ?? []);
    yield put(actions.fetchNotificationConfigsSuccess(configs));
  } catch (error: any) {
    yield put(actions.updateNotificationConfigFailure(error.message || 'Failed to update notification config'));
  }
}

export default function* loyaltyNotificationsSaga() {
  yield takeLatest(T.FETCH_NOTIFICATION_CONFIGS_REQUEST, fetchNotificationConfigsSaga);
  yield takeLatest(T.UPDATE_NOTIFICATION_CONFIG_REQUEST, updateNotificationConfigSaga);
}
